import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Modal from '../../../components/shared/Modal';

const schema = yup.object().shape({
  nome: yup.string().required('O nome é obrigatório'),
  ativo: yup.boolean(),
});

export default function EquipeModal({ isOpen, onClose, onSave, equipe }) {
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      nome: '',
      ativo: true,
    }
  });

  useEffect(() => {
    if (isOpen) {
      if (equipe) {
        reset(equipe);
      } else {
        reset({
          nome: '',
          ativo: true,
        });
      }
    }
  }, [isOpen, equipe, reset]);

  const onSubmit = (data) => {
    onSave(data);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={equipe ? 'Editar Equipe' : 'Nova Equipe'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nome</label>
            <input {...register('nome')} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" />
            <p className="text-red-500 text-xs mt-1">{errors.nome?.message}</p>
          </div>
          <div className="flex items-center">
            <input type="checkbox" {...register('ativo')} className="h-4 w-4 text-primary border-gray-300 rounded" />
            <label className="ml-2 block text-sm text-gray-900">Ativo</label>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-4">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
            Cancelar
          </button>
          <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-secondary">
            Salvar
          </button>
        </div>
      </form>
    </Modal>
  );
}
